var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoenixWithoutName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.929 0C17.7946 9.07171 20.3071 17.6019 23.449 22.4461C24.4887 23.8656 24.4437 23.8457 25.9249 25.7056C26.1665 26.0143 26.4082 26.3313 26.6499 26.6566C30.6938 31.7142 32.9506 37.4394 28.0774 46.4072C41.3246 32.1406 25.0816 16.6986 22.929 0Z",
    fill: "url(#paint0_linear_54_101122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8214 12.8783C16.3528 26.2332 19.2137 26.5279 24.6292 31.1785C29.9659 35.6525 29.0298 41.4424 27.3917 46.4774C36.9044 29.442 20.043 24.2892 14.8218 12.8783H14.8214Z",
    fill: "url(#paint1_linear_54_101122)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3984 49.204C8.95946 48.1158 3.32493 42.1072 0.00022196 34.5867C-0.0670883 47.6246 15.1893 52.7607 25.7671 48.5728C24.6319 48.9152 23.4291 49.1592 22.2039 49.2881C20.6048 49.4591 18.9664 49.4397 17.3984 49.204Z",
    fill: "url(#paint2_linear_54_101122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.611 40.4404C9.52719 48.9623 20.0485 50.2525 26.8493 47.5963C18.7417 49.9664 12.2559 46.6874 8.611 40.4404Z",
    fill: "url(#paint3_linear_54_101122)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6319 26.6081C42.8909 25.8035 41.92 24.4125 41.1056 22.6899C40.9428 24.1556 40.9783 25.6411 41.785 26.7461C40.2798 27.1163 38.792 27.9417 37.5368 29.1669C37.9358 35.3774 36.7106 41.2063 30.4859 45.8794C41.0634 40.4826 39.5237 32.7995 44.0199 30.9059C46.2624 29.8962 48.3758 30.7293 50 33.1133C49.4817 29.0898 47.257 27.0335 44.6319 26.6078V26.6081Z",
    fill: "url(#paint4_linear_54_101122)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3138 2.51054C30.5338 7.75337 27.6785 10.6341 30.7611 21.0801C33.5038 28.0646 35.2545 34.8194 32.2141 41.3802C31.6013 42.8053 30.7528 44.1994 29.6232 45.5515L29.6092 45.5682C29.4408 45.7701 29.2636 45.972 29.0836 46.174C45.605 35.1107 30.4072 16.4626 35.3138 2.51019V2.51054Z",
    fill: "url(#paint5_linear_54_101122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_101122",
    x1: 0.862765,
    y1: -6.12393,
    x2: 45.7383,
    y2: 47.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_101122",
    x1: -4.91932,
    y1: -1.29861,
    x2: 39.9562,
    y2: 52.4774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_101122",
    x1: -16.956,
    y1: 8.74589,
    x2: 27.9195,
    y2: 62.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54_101122",
    x1: -14.58,
    y1: 6.76247,
    x2: 30.2959,
    y2: 60.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54_101122",
    x1: 2.06078,
    y1: -7.12374,
    x2: 46.9363,
    y2: 46.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_54_101122",
    x1: 4.23601,
    y1: -8.93894,
    x2: 49.1119,
    y2: 44.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoenixWithoutName);
export default __webpack_public_path__ + "static/media/phoenixWithoutName.80ffc08f61392165c15306b341c27ad9.svg";
export { ForwardRef as ReactComponent };